<template>
    <div>
		{{ApiData}}
		<!--
		<div>
			<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
		</div>
		<div>
			<el-table :data="ApiData" style="width: 100%;">
				<el-table-column
					label="ID"
					property="id"
					width="80"
					sortable
			>
			</el-table-column>
			<el-table-column 
					min-width="180"
					label="Название"
					property="name"
					sortable
			>
			</el-table-column>
			
			<el-table-column
					width="160"
					label="Действие"
					align="right"                    	
			>
					<template slot-scope="scope">			
							<el-tooltip content="Изменить" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-success" @click="GoEdit(scope.row)">
										<i class="tim-icons icon-book-bookmark"></i>
									</button>											
								</el-button>
							</el-tooltip>		
							<el-tooltip content="Удалить" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
										<i class="tim-icons icon-trash-simple"></i>
									</button>											
								</el-button>
							</el-tooltip>		
					</template>
			</el-table-column>
			
			</el-table>
		</div>
		-->
    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import Pagination from 'src/our_components/RePagination';

export default {
	name: 'template-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// ReFilterBtn,
        // ReFilter,
        // ReFormPrinter,
        // Pagination,
	},
	data() {
		return {
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('template.GET',{flt:{'list':'true'}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFormConfig() {
			this.$GVO.ApiCall('template.GET_FORM_MODEL',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'template.INS',apiParam:{iData:[]}};
        },
		SuccessGo(evt,dopParam){
	        this.masAllFormParams = this.currentFormConfig();
		},
		DeleteRow(row){
			// console.log(row);
			if(row.id != null){
				/*
				this.$GVO.ApiCall('template.DEL',{ flt:{id: row.id}}) 
					.then((objApi) => {
						if(objApi.success === true){
							this.getApiData();
						}else{
							alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.log(errorObjApi);});
				*/
			}
			this.getApiData();
		},
		GoEdit(row){
			// console.log(row);
			if(row.id != null){

			}
		}
	},		
	mounted() {
		this.getApiData();
	}
};
</script>
<style>
</style>
